//@ts-nocheck

import React, { useEffect, useState, ReactNode } from "react";

import { Switch } from "../Switch/Switch";
import { useDispatch, useSelector } from "react-redux";
import { setWidgetSettingsVisibility } from "../../../appRedux/actions/Setting";

import IntlMessages from "../../../util/IntlMessages";

import "./tabs.less";

type TabType = {
   key: string;
   props: any;
};

type TabsArray = TabType[];

interface TabsProps {
   children: ReactNode | TabType | TabsArray;
   defaultActiveKey?: string;
   style?: React.CSSProperties;
   className?: string;
   tabPosition?: "top" | "bottom" | "left" | "right";
   extraContent?: ReactNode;
   tabsType?: string;
}

// don't conditionally render the first object!

export const Tabs: React.FC<TabsProps> = ({
   children,
   defaultActiveKey,
   style,
   className,
   tabPosition = "top",
   extraContent,
   tabsType
}) => {
   const [allTabs, setAllTabs] = useState<TabsArray>([]);
   const [currentTab, setCurrentTab] = useState<string>(defaultActiveKey || allTabs[0]?.key || "1");
   const { areWidgetSettingsVisible } = useSelector((state: any) => state.settings);

   const dispatch = useDispatch();

   useEffect(() => {
      const defActive = defaultActiveKey || allTabs[0]?.key;
      setCurrentTab(defActive);
   }, [allTabs, defaultActiveKey]);

   const createTabsNav = (TabsArray: TabsArray) => {
      if (TabsArray instanceof Array) {
         TabsArray.forEach((tab) => {
            if (tab instanceof Array) {
               tab.forEach((obj) => {
                  if (!allTabs.find((item) => item?.key == obj?.key)) {
                     setAllTabs((prevAllTabs) => [...prevAllTabs, obj]);
                  }
               });
            } else if (
               tab !== undefined &&
               tab !== null &&
               typeof tab !== "boolean" &&
               !allTabs.find((item) => item?.key == tab?.key)
            ) {
               setAllTabs((prevAllTabs) => [...prevAllTabs, tab]);
            }
         });
      }

      return (
         allTabs.length > 1 &&
         allTabs.map((tab, index) => {
            return (
               <div
                  className={tab?.key == currentTab ? "tab tab-active" : "tab"}
                  key={index}
                  onClick={() => {
                     setCurrentTab(tab?.key);
                     if (tab?.props?.onChange) {
                        tab.props.onChange(tab?.key);
                     }
                     if (tab?.props?.updateCasesList && tab?.props?.profileId >= 0) {
                        tab?.props?.updateCasesList(tab?.props?.profileId);
                     }
                  }}
               >
                  {tab?.props?.tab?.props?.children?.props?.children[1]?.props?.children ? (
                     <>{tab?.props?.tab?.props?.children?.props?.children[1]?.props?.children}</>
                  ) : (
                     <>
                        <IntlMessages id={tab?.props?.tab?.props?.id || tab?.props?.tab || "Tab"} />
                     </>
                  )}
               </div>
            );
         })
      );
   };

   return (
      <>
         <div
            style={style}
            data-testid="tabs-container"
            className={`tabs-container tabs-container-${tabPosition} ${className}`}
         >
            <div className="tabs-nav">
               {children instanceof Array && createTabsNav(children)}
               {extraContent && <div className="extra-content">{extraContent}</div>}
               {tabsType === "widgets" && (
                  <div className="tabs-nav__config-mode-container">
                     <div className="config-mode-text">
                        <IntlMessages id="widget.configuration.mode" />
                     </div>
                     <Switch
                        defaultChecked={areWidgetSettingsVisible}
                        onChange={(checked) => dispatch(setWidgetSettingsVisibility(checked))}
                        className="config-mode-switch"
                     />
                  </div>
               )}
            </div>
            {children instanceof Array ? (
               children?.map((tab, index) => {
                  if (tab instanceof Array) {
                     return tab.filter((obj: TabType) => {
                        if (obj?.key == currentTab) {
                           return (
                              <div key={index} className="tabs-body">
                                 <>{obj}</>
                              </div>
                           );
                        }
                     });
                  } else if (tab?.key == currentTab) {
                     return (
                        <div key={index} className="tabs-body">
                           <>{tab}</>
                        </div>
                     );
                  }
               })
            ) : (
               <div className="tabs-body">
                  <>{children}</>
               </div>
            )}
         </div>
      </>
   );
};
